module.exports = __webpack_public_path__ + "static/media/perso-02@3x.8512f93b.png";